import { t } from "i18next";
import React from "react";
import { Link } from "react-router-dom";
import "./LoyaltyPoint.scss";

const LoyaltyPoint = () => {
  return (
    <Link
      className="u-i-p-a-loyaltyPoint-bc"
      to={{
        search: "?profile=open&account=bonuses&page=loyalty-points",
      }}
    >
      <img
        src="https://cmsbetconstruct.com/content/images/loyalty_points/bronze.png"
        className="loyaltyPointsCurrentPlanMedal-bc"
        alt=""
      />
      <p className="ellipsis">{t("admin.LoyaltyPoints")}</p>
      <span>*******</span>
    </Link>
  );
};

export { LoyaltyPoint };
